import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../../endpoint";
import type { BlogPost, BlogFormData, PaginatedPosts, BlogStatus } from "../types";

export const listAdminPosts = async (page = 1, limit = 20): Promise<PaginatedPosts> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.CMS.BLOG.LIST_ADMIN, {
    params: { page, limit },
  });
  return data;
};

export const uploadBlogCoverImage = async (file: File): Promise<{ logoUrl: string }> => {
  const formData = new FormData();
  formData.append("logo", file);
  const { data } = await privateClient.post("/uploads/logo", formData);
  return data;
};

export const listBlogCategoryNames = async (): Promise<string[]> => {
  const { data } = await privateClient.get("/cms/blog/admin/categories");
  return data.categories ?? [];
};

export const getAdminPost = async (id: number): Promise<BlogPost> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.CMS.BLOG.DETAIL_ADMIN(id));
  return data.post ?? data;
};

export const createPost = async (payload: BlogFormData): Promise<BlogPost> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.CMS.BLOG.CREATE, payload);
  return data.post ?? data;
};

export const updatePost = async (id: number, payload: BlogFormData): Promise<BlogPost> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.BLOG.UPDATE(id), payload);
  return data.post ?? data;
};

export const setPostStatus = async (id: number, status: BlogStatus): Promise<BlogPost> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.BLOG.SET_STATUS(id), { status });
  return data.post ?? data;
};

export const deletePost = async (id: number): Promise<void> => {
  await privateClient.delete(SUPER_ADMIN_ENDPOINTS.CMS.BLOG.DELETE(id));
};